import { createQueryProvider } from "@viajero/shared-ui/query";

export const { QueryProvider, getQueryClient } = createQueryProvider(
  "__viajero_guest_QueryClient__",
);
